import { ROUTES } from '@/shared/routing';
import { isSafeRedirectUrl } from './safe-redirect';
import type { Navigator } from './types';

/**
 * 검증된 redirect URL 로 이동 — open-redirect 차단은 `isSafeRedirectUrl`(현재 호스트 == 대상 호스트
 * 또는 allowlist) 가 담당.
 *   - same-host  → SPA navigate (`navigator.replace`, 게이트 복귀라 history 에 안 남김)
 *   - allowlist cross-host → full page nav (`location.href`)
 *   - 그 외(미안전·null) → HOME
 */
export function navigateToUrl(navigator: Navigator, url: string | null | undefined): void {
  if (!isSafeRedirectUrl(url)) {
    navigator.replace(ROUTES.DASHBOARD);
    return;
  }
  const target = new URL(url, window.location.origin);
  if (target.host === window.location.host) {
    navigator.replace(`${target.pathname}${target.search}${target.hash}`);
  } else {
    window.location.href = url;
  }
}
